import { Component, Input, OnInit } from '@angular/core';
import { DwComponent, DwComponentType } from '@devwareapps/devware-cap';
import { CalendarControllerToken } from '../../../calendar/services/interfaces/calendar-controller-service.interface';
import { SchoolCalendarControllerService } from '../../services/school-calendar-controller.service';

@DwComponent({
  key: 'school-booking-calendar',
  name: 'School Booking Calendar',
  componentType: DwComponentType.pageComponent,
  isGlobal: true,
})
@Component({
  selector: 'app-school-calendar',
  templateUrl: './school-calendar.component.html',
  styleUrls: ['./school-calendar.component.scss'],
  providers: [
        {
        provide: CalendarControllerToken,
        useClass: SchoolCalendarControllerService
      }
    ]
})
export class SchoolCalendarComponent implements OnInit {
  @Input() hideActionBar: boolean = false;
  @Input() compactView: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

}
